// Telegram уведомления
const TELEGRAM_BOT_TOKEN = '8080420968:AAEcGAv--Ah0kwPT3u_Eq_-X_emy1sd3Pr8'; // Получить у @BotFather
const TELEGRAM_CHAT_ID = '704907731'; // Получить у @userinfobot

export const sendTelegramNotification = async (message) => {
  try {
    const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: TELEGRAM_CHAT_ID,
        text: message,
        parse_mode: 'HTML'
      })
    });
    return response.ok;
  } catch (error) {
    console.error('Ошибка отправки в Telegram:', error);
    return false;
  }
};

export const notifyNewOrder = (order) => {
  const message = `
🛒 <b>Новый заказ!</b>

👤 Клиент: ${order.customer.name}
📞 Телефон: ${order.customer.phone}
📧 Email: ${order.customer.email || '-'}
📍 Адрес: ${order.customer.address}

💰 Сумма: ${order.totalPrice}₽
📦 Товаров: ${order.totalItems} шт.

${order.customer.comment ? `💬 Комментарий: ${order.customer.comment}` : ''}
  `.trim();
  
  return sendTelegramNotification(message);
};

export const notifyNewConsultation = (consultation) => {
  const message = `
💬 <b>Новая заявка на консультацию!</b>

👤 Имя: ${consultation.name}
📞 Телефон: ${consultation.phone}

${consultation.question ? `❓ Вопрос: ${consultation.question}` : ''}
  `.trim();
  
  return sendTelegramNotification(message);
};
